import type { ICashbackMissingClaimFormResources } from "@/src/cashback/CashbackMissingClaimForm.Resources";

export const CashbackMissingClaimFormResourcesEn: ICashbackMissingClaimFormResources = {
    visaChannelTitle: "Purchase",
    offlineChannel: "Offline",
    onlineChannel: "Online",
    transactionDateLabel: "Order date:",
    transactionDatePlaceholder: "day . month . year",
};
